import { EntityType } from "./enums/entityType";
import { ThermalRegime } from "./enums/Space-properties-enums.model"
import { ProjectEntity } from "./project-entity.model";
import { StructureProperties } from "./structure-properties.model"

export class FloorDefinition extends ProjectEntity {
    entityType: EntityType = EntityType.FloorDefinition;
    name: string;
    description: string = "";
    floorComposition: StructureProperties = null;
    thermalRegimeUnderFloor: ThermalRegime = null;
}